import AbstractApiModel from '@/models/abstracts/AbstractApiModel';
import doc from '@model-core/decorators/doc';

/** Statut d'une période (enum App\Entity\PeriodStatus de l'API, GET /period_statuses) : Ouverte, Clôturée */
export default class PeriodStatusModel extends AbstractApiModel {
  protected _path = '/period_statuses/{?id}';

  @doc.string declare reference: string;
  @doc.string declare label: string;

  /** URN à envoyer à l'API pour écrire la relation (corps d'un POST / PATCH) ; un filtre prend l'id */
  get urn(): string {
    return this.get<string, string>('@urn', `$:teiji:period_status:${this.id}`);
  }
}
